import Vue from "vue";
import Router from "vue-router";
import AppHeader from "./layout/AppHeader";
import AppHeaderLight from "./layout/AppHeaderLight";
import AppFooter from "./layout/AppFooter";

// My views
import Ping from "./views/Ping.vue";
import Noise from "./views/Noise.vue";
import Dice from "./views/Dice.vue";
import Tip from "./views/Tip.vue";
// Footer
import AppFooterNoise from "./layout/AppFooterNoise";
import AppFooterPing from "./layout/AppFooterPing";
import AppFooterDice from "./layout/AppFooterDice";
import AppFooterTip from "./layout/AppFooterTip";
// Other
import Imprint from "./views/Imprint";
import PrivacyStatement from "./views/PrivacyStatement";
import Acknowledgements from "./views/Acknowledgements";

Vue.use(Router);

export default new Router({
  linkExactActiveClass: "active",
  mode: "history",
  routes: [
    {
      path: "/",
      redirect: "/noise"
    },
    {
      path: "/imprint",
      name: "imprint",
      components: {
        header: AppHeader,
        default: Imprint,
        footer: AppFooter
      }
    },
    {
      path: "/dataprivacy",
      name: "dataprivacy",
      components: {
        header: AppHeader,
        default: PrivacyStatement,
        footer: AppFooter
      }
    },
    {
      path: "/acknowledgements",
      name: "acknowledgements",
      components: {
        header: AppHeader,
        default: Acknowledgements,
        footer: AppFooter
      }
    },
    {
      path: "/noise",
      name: "noise",
      components: {
        header: AppHeader,
        default: Noise,
        footer: AppFooterNoise
      }
    },
    {
      path: "/ping",
      name: "ping",
      components: {
        header: AppHeaderLight,
        default: Ping,
        footer: AppFooterPing
      }
    },
    {
      path: "/dice",
      name: "dice",
      components: {
        header: AppHeaderLight,
        default: Dice,
        footer: AppFooterDice
      }
    },
    {
      path: "/tip",
      name: "tip",
      components: {
        header: AppHeader,
        default: Tip,
        footer: AppFooterTip
      }
    },
    {
      path: "*",
      redirect: "/"
    }
  ],
  scrollBehavior: to => {
    if (to.hash) {
      return { selector: to.hash };
    } else {
      return { x: 0, y: 0 };
    }
  }
});
